import { l as i } from "../../../../_virtual/leaflet-src.js";
function a(t, n, d) {
  n.bounds instanceof i.LatLngBounds && n.bounds !== d.bounds && t.setBounds(n.bounds), n.opacity != null && n.opacity !== d.opacity && t.setOpacity(n.opacity), n.zIndex != null && n.zIndex !== d.zIndex && t.setZIndex(n.zIndex);
}
export {
  a as updateMediaOverlay
};
